import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormTypeSelection from './FormTypeSelection';
import { checkoutStarted } from '../../../../actions/tracking';
import { resetUserInfoError } from '../../../../actions/userInfo';
import styles from './SignInUp.scss';


class SignInUp extends Component {
  componentDidMount() {
    this.props.checkoutStarted();
    this.props.resetUserInfoError();
  }

  render() {
    return (
      <div className={styles.root}>
        <FormTypeSelection />
      </div>
    );
  }
}


export default connect(null, { checkoutStarted, resetUserInfoError })(SignInUp);
